var map = {
	"./FrameDF.png": 800,
	"./FrameDFDC.png": 134,
	"./FrameDFDG.png": 4172,
	"./FrameDL.png": 6354,
	"./FrameFD.png": 9113,
	"./FrameGF.png": 4628,
	"./FrameJJBX.png": 9985,
	"./FrameJJBXG.png": 3032,
	"./FrameLL.png": 2916,
	"./FrameMVP.png": 3508,
	"./FrameTCJL.png": 6147,
	"./FrameYCS.png": 8548
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 888;